import { CheckCircle, Clock, FileText, Unlock, Lock, Star } from "lucide-react";

export const getLevelStyling = (order) => {
  const styles = [
    { color: "from-cyan-500 to-blue-500", iconBg: "bg-cyan-500" }, // Level 1
    { color: "from-purple-500 to-pink-500", iconBg: "bg-purple-500" }, // Level 2
    { color: "from-orange-500 to-red-500", iconBg: "bg-orange-500" }, // Level 3
    { color: "from-green-500 to-teal-500", iconBg: "bg-green-500" }, // Level 4
    { color: "from-indigo-500 to-violet-500", iconBg: "bg-indigo-500" }, // Level 5
    // Add more predefined styles for higher orders if needed
  ];
  return styles[(order - 1) % styles.length] || styles[0]; // Cycle through styles, default to first
};

export const getStatusBadgeColor = (status) => {
  switch (status) {
    case "completed":
      return "bg-green-700 text-green-100";
    case "in-progress":
      return "bg-blue-700 text-blue-100";
    case "not-started": // Light blue badge for 'not-started'
      return "bg-blue-500 text-blue-100";
    case "unlocked":
      return "bg-purple-700 text-purple-100";
    case "locked": // Gray badge for locked
      return "bg-slate-700 text-slate-300";
    default:
      return "bg-slate-700 text-slate-300";
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "completed":
      return <CheckCircle className="w-4 h-4 text-green-400" />;
    case "in-progress":
      return <Clock className="w-4 h-4 text-blue-400" />;
    case "not-started":
      return <FileText className="w-4 h-4 text-blue-300" />; // Icon color for 'not-started'
    case "unlocked":
      return <Unlock className="w-4 h-4 text-purple-400" />;
    case "locked":
      return <Lock className="w-4 h-4 text-slate-400" />; // Icon color for 'locked'
    default:
      return null;
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case "completed":
      return "border-green-500 bg-green-900/20";
    case "in-progress":
      return "border-blue-500 bg-blue-900/20";
    case "not-started": // Light blue for 'not-started'
      return "border-blue-300 bg-blue-900/10";
    case "unlocked": // Purple for explicitly unlocked by admin
      return "border-purple-500 bg-purple-900/20";
    case "locked": // Gray for locked
      return "border-slate-600 bg-slate-800/50";
    default:
      return "border-slate-600 bg-slate-800";
  }
};


 export const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-3 h-3 ${
          i < rating ? "text-yellow-400 fill-current" : "text-slate-600"
        }`}
      />
    ));
  };